import { sanitizeFetchType } from 'react-admin'
import { PassageDto } from '../../dto/device/passages/passage.dto'
import { ResourceName } from '../../ResourceName'
import {
  ToggleButtonAction,
  ToggleButtonState,
  ToggleType,
} from './passage-set-boolean-status-button'
import { DateTime } from '../../common/date-time'

type Mutation = {
  type: string
  resource: string
  // eslint-disable-next-line @typescript-eslint/ban-types
  payload?: object
}

const turnOffMutation = (
  { id }: PassageDto,
  recurringJobName?: string,
  cronExpression?: string,
  scheduledAt?: DateTime,
): Mutation => ({
  type: sanitizeFetchType('setReversedRotationDirectionState'),
  resource: ResourceName.PASSAGES,
  payload: {
    passageId: id,
    reversedRotationDirectionState: false,
    recurringJobName,
    cronExpression,
    scheduledAt,
  },
})

const turnOnMutation = (
  { id }: PassageDto,
  recurringJobName?: string,
  cronExpression?: string,
  scheduledAt?: DateTime,
): Mutation => ({
  type: sanitizeFetchType('setReversedRotationDirectionState'),
  resource: ResourceName.PASSAGES,
  payload: {
    passageId: id,
    reversedRotationDirectionState: true,
    recurringJobName,
    cronExpression,
    scheduledAt,
  },
})

type State = {
  mutateQuery?: (
    passage: PassageDto,
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => Mutation
} & ToggleButtonState

export const passageSetReverseDirectionButtonInitialState = {
  type: ToggleType.OFF,
  text: 'resources.passages.actions.setLockState.turnOn',
}

export const passageSetReverseDirectionButtonReducer = (
  state: State,
  { type }: ToggleButtonAction,
): State => {
  switch (type) {
    case ToggleType.OFF: {
      return {
        type,
        text: 'resources.passages.actions.setReverseDirectionState.turnOn',
        mutateQuery: turnOnMutation,
      }
    }
    case ToggleType.ON: {
      return {
        type,
        text: 'resources.passages.actions.setReverseDirectionState.turnOff',
        mutateQuery: turnOffMutation,
      }
    }
    default:
      throw new Error()
  }
}
